import { inject, injectable, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";
import { Snippets } from "../../common/snippets";
import { CommonModule } from "../common.module";
import { ApiModule } from "../common/api/api.module";
import { EmailButtonInfoDTO, EmailButtonInputDTO, EmailInputDTO, ErrorTypes } from "../common/api/autogenerated";
import { type ButtonInfo, DashboardTooltipButtonManagerModule, type UrlData } from "../common/dashboard-tooltip-button-manager/dashboard-tooltip-button-manager.module";
import { RequestInterceptorModule } from "../common/request-interceptor.module";
import { ScreenshotModule } from "../common/screenshot.module";
import { UiModule } from "../common/ui.module";
import ContactOwnerPopup from './ContactOwnerPopup.vue';
@singleton()
export class ContactOwnerModule extends Module {
    public name: string = 'ContactOwnerModule';
    public acceptedLicenseFlags: string[] = ['EmailIntegrationbutton'];
    public shouldRun(context: ExtensionContext): boolean { return context === ExtensionContext.vizql; }

    constructor(
        @inject(CommonModule) private common: CommonModule,
        @inject(ApiModule) private apiModule: ApiModule,
        @inject(DashboardTooltipButtonManagerModule) private dashboardTooltipButtonManager: DashboardTooltipButtonManagerModule,
        @inject(ScreenshotModule) private screenshot: ScreenshotModule,
        @inject(UiModule) private uiModule: UiModule) {
        super([common, apiModule, dashboardTooltipButtonManager, screenshot, uiModule]);
    }
    public async run(): Promise<void> {

        this.dashboardTooltipButtonManager.registerButtonFn(async (urlData: UrlData) => {
            const api = await this.apiModule.apiRequest(c => c.apiEmailIntegrationButtonInfo(new EmailButtonInputDTO({
                serverId: window.stm.config.serverId,
                workbookUrl: urlData.workbook
            })));
            let disabled = false;
            if (!api.success) {
                // if feature is disabled, simply don't show button
                if (api.error?.error === ErrorTypes.EmailIntegrationDisabled) {
                    return undefined;
                } else {
                    // if any other error is thrown, show the button, but make it disabled
                    disabled = true;
                }
            }
            
            // get the button HTML
            return {
                disabled,
                text: 'Contact Owner',
                svgXml: `<svg xmlns='http://www.w3.org/2000/svg' width='22.001' height='15'><path fill='currentColor'  d='M.997 0C.547 0 0 .398 0 .889V13.879C0 14.495.56 15 1.049 15H21.044c.525 0 .957-.501.957-1.004V1.006c0-.614-.433-1.006-.997-1.006zm.717.996h18.567l-9.287 7.212zm-.71.563L11 9.21l10.007-7.545-.016 5.1v7.216H1.004L.996 6.764z' /></svg>`,
                svgMarginTop: 4,
                onClicked: () => this.btnClick(api.value!)
            } as ButtonInfo;
        });


    }

    private async btnClick(data: EmailButtonInfoDTO) {
        try {
            await this.openPopup(data);
        } catch (e) {
            this.log.e('Failed to open popup', e);
        }
    }

    private async openPopup(contactOwnerData: EmailButtonInfoDTO): Promise<void> {
        
        const doc = (await this.common.getDashboardDocument())!;

        // take screenshot first
        const ss = await this.screenshot.takeScreenshot(doc!.body, 5, 500).catch(e => {
            this.log.e('Failed to take a screenshot', e);
            return undefined;
        });
        // create a div
        this.uiModule.injectUI(ContactOwnerPopup, undefined, {
            info: contactOwnerData,
            screenshot: ss
        });
        return;
    }
}